/* eslint-disable import/no-cycle */
import { handleActions } from 'redux-actions';

// FALCON UPLOADER
import { ROOT_SLICE as ROOT_FALCON_UPLOADER } from './slices/FalconUploader/constants';
import { initialState as falconUploaderInitialState } from './slices/FalconUploader/initialState';
import FalconUploaderReducerParts from './slices/FalconUploader/reducerParts';

const initialState = {
	[ROOT_FALCON_UPLOADER]: {
		...falconUploaderInitialState
	},
};

const reducerParts = {
	...FalconUploaderReducerParts,
};

export { ROOT_SLICE } from './constants';
export default handleActions(reducerParts, initialState);
